import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  isLoading: false,
  stage: {},
}

const stageSlice = createSlice({
  name: "stage",
  initialState,
  reducers: {
    requestPending: (state) => {
      state.isLoading = true
    },
    addStageSuccess: (state, { payload }) => {
      state.isLoading = false
      state.stage = payload
    },
  },
})

const { actions, reducer } = stageSlice

export const { requestPending, addStageSuccess } = actions

export default reducer
